export default {
  agentSkillsSessionComposerDetachingEnabledState(state) {
    return state.sessionComposerDetachingEnabled !== false;
  },
};
